import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  EMPTY_LOGIN_FORM,
  LOGIN_COPY,
  type LoginFormState,
} from '../constants/auth'
import { APP_ROUTES } from '../constants/routes'
import { ApiError } from '../helpers/api-client'
import { unlockNotificationSound } from '../helpers/notification-alerts'
import { useAuth } from './useAuth'

export function useLoginForm() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState<LoginFormState>(EMPTY_LOGIN_FORM)
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  function onChange(patch: Partial<LoginFormState>) {
    setForm((current) => ({ ...current, ...patch }))
    if (error) setError('')
  }

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    unlockNotificationSound()
    setSubmitting(true)
    setError('')
    try {
      await login(form.email, form.password)
      navigate(APP_ROUTES.home, { replace: true })
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : LOGIN_COPY.genericError,
      )
    } finally {
      setSubmitting(false)
    }
  }

  return {
    form,
    error,
    submitting,
    onChange,
    onSubmit,
  }
}
